import { Http } from '../../../../../../helpers/axois';
import { Group } from './types';

type Schema = 'entity' | 'intent';

type AddSchemaPayload = {
	type: Schema;
	name: string;
	branchId: string;
};

type EditSchemaPayload = AddSchemaPayload & { id: string };

export type UpdateEntityValuePayload = {
	create?: string[];
	update?: Record<string, string>;
	delete?: string[];
};

export const api = {
	async addSchema(appId: string, payload: AddSchemaPayload) {
		try {
			const path = baseURL(appId) + '/schema-layout';
			const res = await Http.post(path, payload).toPromise();
			return res;
		} catch (err) {
			throw err;
		}
	},

	async editSchema(appId: string, payload: EditSchemaPayload) {
		try {
			const path = baseURL(appId) + '/schema-layout';
			const res = await Http.put(path, payload).toPromise();
			return res;
		} catch (err) {
			throw err;
		}
	},

	async getSchema(appId: string, branchId: string, type: Schema) {
		try {
			const path =
				baseURL(appId) + `/schema-layout?type=${type}&branchId=${branchId}`;
			const res: any = await Http.get(path).toPromise();
			return res;
		} catch (err) {
			throw err;
		}
	},

	async deleteSchema(
		appId: string,
		branchId: string,
		schema: 'entities' | 'intents',
		schemaId: string,
	) {
		try {
			const path =
				baseURL(appId) +
				`/schema-layout/${schema}/${schemaId}?branchId=${branchId}`;
			await Http.delete(path).toPromise();
		} catch (err) {
			throw err;
		}
	},

	async updateEntityValue(
		appId: string,
		branchId: string,
		entityId: string,
		payload: EditSchemaPayload,
	) {
		try {
			const body: any = {
				branchId,
			};
			Object.entries(payload).forEach(([key, value]) => {
				if (Object.keys(value).length) {
					body[key] = value;
				}
			});
			const path =
				baseURL(appId) + `/schema-layout/entities/${entityId}/entity-values`;
			await Http.put(path, body).toPromise();
		} catch (err) {
			throw err;
		}
	},

	async getGroups(appId: string, branchId: string, intentId: string) {
		const path =
			baseURL(appId) +
			`/data-labelling/intents/${intentId}/groups?branchId=${branchId}`;
		const res: any = await Http.get(path).toPromise();
		return res as Group[];
	},

	async createGroup(appId: string, intentId: string, payload: any) {
		const path = baseURL(appId) + `/data-labelling/intents/${intentId}/groups`;
		const res = await Http.post(path, payload).toPromise();
		return res;
	},

	async updateGroup(
		appId: string,
		intentId: string,
		groupId: string,
		payload: any,
	) {
		const path =
			baseURL(appId) + `/data-labelling/intents/${intentId}/groups/${groupId}`;
		const res = await Http.put(path, payload).toPromise();
		return res;
	},

	async deleteGroup(
		appId: string,
		branchId: string,
		intentId: string,
		groupId: string,
	) {
		const path =
			baseURL(appId) +
			`/data-labelling/intents/${intentId}/groups/${groupId}?branchId=${branchId}`;
		const res = await Http.delete(path).toPromise();
		return res;
	},
};

function baseURL(appId: string) {
	return `/apps/${appId}/chat-nlu/basicNLP`;
}
